module.exports = __webpack_public_path__ + "static/media/pdf.3fa92281.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdf.svg
// module id = 682
// module chunks = 2